<template>
    <div id="new-teamgram-channel-form">
        <a-form>
            <div class="form-wrapper">
                <div class="input-wrapper">
                    <label>{{$t("billing.companyName")}}</label>
                    <a-input v-model="form.company" v-validate="'required'" name="url" />
                </div>
                <div class="input-wrapper">
                    <label>API Key</label>
                    <a-input v-model="form.apiKey" v-validate="'required'" name="url" />
                </div>
            </div>
        </a-form>

        <div class="form-footer">
            <div class="actions">
                <a-button @click="handleCancel">{{ $t("message.cancel")}}</a-button>
                <a-button class="pr-confirm-btn" @click="handleSubmit" type="primary" :disabled="loading">
                    {{ $t("mail.connect")}}
                </a-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import _ from "lodash";

export default {
    name: "CreateTicimaxChannel",
    props: {
        channel: {
            type: Object,
            default: () => {},
        },
    },
    components: {},
    data() {
        return {
            form: {
                company: "",
                apiKey: "",
            },
            loading: false,
            clone: _.cloneDeep(this.channel),
            submitClicked: false,
        };
    },
    computed: {
        ...mapState({
            siteId: (state) => state.site.site?._id,
        }),
    },
    methods: {
        ...mapActions({
            createChannel: "channel/createChannel",
        }),
        getErrorStatus(fieldName) {
            return this.form[fieldName].length < 1 && this.submitClicked ? "error" : "";
        },
        getErrorMessage(fieldName) {
            return this.form[fieldName].length < 1 && this.submitClicked ? this.$t("message.requiredChannel") : "";
        },
        handleCancel() {
            this.$emit("cancel");
        },
        completeCreateChannel(payload) {
            const data = {
                payload,
                type: "teamgram",
                name: "TeamGram",
            };
            return this.createChannel(data)
                .then(() => {
                    this.$message.success("Channel created successfully");
                    this.$emit("ok");
                })
                .catch((err) => {
                    this.$message.error("Failed to create channel");
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        handleSubmit() {
            this.submitClicked = true;
            this.completeCreateChannel({
                company: this.form.company,
                apiKey: this.form.apiKey,
            });
        },
    },
    mounted() {},
    beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
#new-teamgram-channel-form {
    min-height: 250px;
    flex-direction: column;

    .form-wrapper {
        padding: 20px;
        display: flex;
        flex-direction: column;
        gap: 10px;

        .webhook-info {
            display: flex;
            gap: 5px;
            justify-content: center;
            padding: 5px;
            overflow-wrap: anywhere;

            .anticon {
                &:hover {
                    color: var(--color-text-info-hover);
                }
            }
        }

        .input-wrapper {
            display: flex;
            flex-direction: column;
            gap: 5px;
            height: 75px;
        }
    }

    .form-footer {
        display: flex;
        justify-content: flex-end;
        padding: 10px;
        margin-top: 20px;
        background: var(--color-bg-default);
        border-top: 1px solid var(--color-border-default);
    }
}
</style>

<style lang="scss">
.new-sms-postacell {
    .custom-modal-body {
        padding: 0px !important;
    }
}
</style>
